var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketPlaceTopRightRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 313,
    viewBox: "0 0 153 313",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_333_609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6643 195.124C61.5704 259.692 130.985 294.551 194.706 272.984C258.427 251.417 292.325 181.591 270.419 117.024C248.513 52.4561 179.098 17.5971 115.377 39.1639C51.656 60.7308 17.7583 130.556 39.6643 195.124Z",
    fill: "url(#paint0_radial_333_609)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_333_609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.7527 173.019C88.977 217.892 136.274 242.438 179.394 227.844C222.513 213.25 245.127 165.043 229.902 120.169C214.678 75.2961 167.381 50.75 124.262 65.3441C81.142 79.9382 58.5285 128.146 73.7527 173.019Z",
    fill: "url(#paint1_radial_333_609)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_333_609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.809 156.216C133.91 171.252 150.083 179.366 164.933 174.34C179.782 169.314 187.685 153.051 182.584 138.015C177.483 122.98 161.31 114.866 146.46 119.892C131.61 124.918 123.707 141.181 128.809 156.216Z",
    fill: "url(#paint2_radial_333_609)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_333_609",
    x: 3.00339,
    y: 2.78113,
    width: 304.076,
    height: 306.585,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_333_609"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_333_609",
    x: 39.0068,
    y: 31.132,
    width: 225.642,
    height: 230.925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_333_609"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_333_609",
    x: 97.2588,
    y: 88.4031,
    width: 116.875,
    height: 117.425,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_333_609"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_333_609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(39.6644 116.91 115.377 -39.0502 155.042 156.074)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#2AC2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AC2D3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_333_609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(27.566 81.2501 78.0748 -26.4249 151.828 146.594)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#2AC2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AC2D3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_333_609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(9.2364 27.2241 26.8878 -9.10034 155.696 147.116)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00160247,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketPlaceTopRightRight);
export default __webpack_public_path__ + "static/media/MarketPlaceTopRightRight.9a98a90c1ca079d15b85ffba5c5b89e5.svg";
export { ForwardRef as ReactComponent };